<zk-input
	[zkStatus]="status"
	[disabled]="variant === 'disabled' || variant === 'readonly' ? true : false"
>
	<span
		class="currency"
		[ngClass]="{
			'-enabled': variant === 'enabled',
			'-enabled-focus': variant === 'enabled-focus',
			'-disabled': variant === 'disabled',
			'-readonly': variant === 'readonly'
		}"
		>{{ currency }}</span
	>

	<input
		zkInputRef
		currencyMask
		[placeholder]="placeholder"
		[(ngModel)]="value"
		[options]="{
			align: variant === 'readonly' ? 'center' : 'left',
			prefix: '',
			thousands: '.',
			decimal: ','
		}"
		(ngModelChange)="onChange()"
		[ngClass]="{
			'-enabled': variant === 'enabled',
			'-disabled': variant === 'disabled',
			'-readonly': variant === 'readonly'
		}"
		[disabled]="disableInput"
	/>

	<button
		*ngIf="buttonVariant !== 'hidden'"
		class="button"
		[ngClass]="{
			'-enabled': buttonVariant === 'enabled',
			'-disabled': buttonVariant === 'disabled'
		}"
		(click)="onClick()"
		[disabled]="buttonVariant === 'disabled' ? true : false"
	>
		{{ buttonLabel }}
	</button>

	<span zkInputMessage>{{ message }}</span>
	<span zkInputLabel></span>
</zk-input>
